import React from 'react';
import { Modal, TextField, Typography } from '@material-ui/core';
import { withStyles } from '@material-ui/styles';
import FormGiornaliero from '../manualecomponents/dettaglio_procedura/FormGiornaliero';
import FormMensile from '../manualecomponents/dettaglio_procedura/FormMensile';
import FormSettimanale from '../manualecomponents/dettaglio_procedura/FormSettimanale';
import FormAnnuale from '../manualecomponents/dettaglio_procedura/FormAnnuale';
import ActionButton from '../../../components/ActionButton';
import PropTypes from 'prop-types';

const styles = (theme) => ({
  modal: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  modalContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    textAlign: 'center',
    backgroundColor: 'white',
    color: 'black',
    borderRadius: '6px',
    padding: theme.spacing(2, 4),
    boxShadow: theme.shadows[6],
    width: '70%',
    maxWidth: '1200px',
    maxHeight: '85vh',
    overflow: 'hidden',
    [theme.breakpoints.down('sm')]: {
      width: '95%',
    },
  },
  modalContent: {
    flex: 1,
    width: '100%',
    minHeight: 0,
    overflowY: 'auto',
  },
  buttonWrapper: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flexShrink: 0,
    width: '100%',
    paddingTop: theme.spacing(2),
  },
  miniModalContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'space-evenly',
    textAlign: 'center',
    backgroundColor: 'white',
    color: 'black',
    borderRadius: '6px',
    padding: theme.spacing(1, 4),
    boxShadow: theme.shadows[6],
    overflowY: 'auto',
    width: '45%',
    maxWidth: '600px',
    height: '240px',
    [theme.breakpoints.down('sm')]: {
      width: '95%',
    },
  },
});

class ModalSelezioneOrario extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      orariDisponibili: [
        '0:00',
        '1:00',
        '2:00',
        '3:00',
        '4:00',
        '5:00',
        '6:00',
        '7:00',
        '8:00',
        '9:00',
        '10:00',
        '11:00',
        '12:00',
        '13:00',
        '14:00',
        '15:00',
        '16:00',
        '17:00',
        '18:00',
        '19:00',
        '20:00',
        '21:00',
        '22:00',
        '23:00',
      ],
      colonneOrario: [],
      altraCadenza: this.props.controlloConformita.altraCadenza,
      selectedOrario: null,
      cadenze: this.props.cadenze,
    };
  }

  onAddCadenza = (cadenza) => {
    let arrayOfCadenze = [...this.state.cadenze];
    arrayOfCadenze.push(cadenza);
    arrayOfCadenze.forEach((item) => {
      item['controlloConformitaId'] = this.props.controlloConformita.id;
    });
    this.setState({
      cadenze: arrayOfCadenze,
    });
  };

  onDeleteCadenza = (selectedOrarioIndex) => {
    this.setState((prevState) => ({
      cadenze: prevState.cadenze.filter(
        (_, index) => index !== selectedOrarioIndex,
      ),
    }));
  };

  render() {
    const { classes } = this.props;

    return (
      <Modal
        open={this.props.open}
        onClose={this.props.onClose}
        className={classes.modal}
      >
        {this.props.mode === 'Normal' ? (
          <div className={classes.modalContainer}>
            <Typography style={{ fontSize: 30, flexShrink: 0 }}>
              Orario del controllo
            </Typography>
            <div className={classes.modalContent}>
              {this.props.cadenza === 'GIORNALIERA' ? (
                <FormGiornaliero
                  onAddCadenza={this.onAddCadenza}
                  cadenze={this.state.cadenze}
                  onDeleteCadenza={this.onDeleteCadenza}
                />
              ) : null}
              {this.props.cadenza === 'SETTIMANALE' ? (
                <FormSettimanale
                  onAddCadenza={this.onAddCadenza}
                  cadenze={this.state.cadenze}
                  onDeleteCadenza={this.onDeleteCadenza}
                />
              ) : null}
              {this.props.cadenza === 'MENSILE' ? (
                <FormMensile
                  onAddCadenza={this.onAddCadenza}
                  cadenze={this.state.cadenze}
                  onDeleteCadenza={this.onDeleteCadenza}
                />
              ) : null}
              {this.props.cadenza === 'ANNUALE' ? (
                <FormAnnuale
                  onAddCadenza={this.onAddCadenza}
                  cadenze={this.state.cadenze}
                  onDeleteCadenza={this.onDeleteCadenza}
                />
              ) : null}
            </div>
            <div className={classes.buttonWrapper}>
              <ActionButton
                label="Chiudi"
                secondaryButton
                onClick={this.props.onClose}
              />
              <ActionButton
                label="Salva"
                onClick={() =>
                  this.props.setCadenzeToControllo(this.state.cadenze)
                }
              />
            </div>
          </div>
        ) : (
          <div className={classes.miniModalContainer}>
            <Typography variant="h5">
              Indicare la cadenza occasionale
            </Typography>
            <TextField
              fullWidth
              variant="outlined"
              size="small"
              value={this.state.altraCadenza || ''}
              onChange={(event) => {
                this.setState({ altraCadenza: event.target.value });
              }}
              inputProps={{ style: { textAlign: 'center' } }}
            />

            <div>
              <ActionButton
                label="Chiudi"
                secondaryButton
                onClick={this.props.onClose}
              />
              <ActionButton
                label="Salva"
                onClick={() =>
                  this.props.addCadenza(
                    this.state.altraCadenza,
                    this.props.indexToUpdate,
                  )
                }
              />
            </div>
          </div>
        )}
      </Modal>
    );
  }
}

ModalSelezioneOrario.propTypes = {
  classes: PropTypes.object.isRequired,
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  controlloConformita: PropTypes.object.isRequired,
  mode: PropTypes.string.isRequired,
  cadenza: PropTypes.string.isRequired,
  cadenze: PropTypes.array.isRequired,
  setCadenzeToControllo: PropTypes.func.isRequired,
  addCadenza: PropTypes.func,
  indexToUpdate: PropTypes.number,
};

export default withStyles(styles)(ModalSelezioneOrario);
